export const IconWallet: {
  name: 'icon_wallet-97cab239aac6'
} = {
  name: 'icon_wallet-97cab239aac6'
}
